import Icon from "components/atoms/icon/Icon";

import { IconType } from "../iconTypes";
import ToggleSwitchComponent from "components/molecules/toggle-switch/ToggleSwitch";
import { useEffect, useRef, useState } from "react";
import React from "react";
import ReactDOM from "react-dom";
import { t } from "i18next";
import CreateAndUpdateTeam from "components/organisms/settings/teams/create-update-team/CreateAndUpdateTeam";
import DeleteTeam from "components/organisms/settings/teams/delete-team/DeleteTeam";
import { useChangeTeamStatus } from "lib/hooks/mutations/Settings/useChangeTeamStatus";
import { usePermissions } from "lib/hooks/shared/usePermissions";
import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";

export const TeamHeaders = (isBroker: boolean) => {

    return [
        {
            id: 1,
            Header: "Creation Date",
            accessor: (row: any) => new Date(row?.created_at),
            Cell: ({ row }: any) => {
                return (
                    <div>
                        {new Date(row.original.created_at).toLocaleDateString('de')}
                    </div>
                );
            },
            isChecked: true
        },
        {
            id: 2,
            Header: "Team Name",
            accessor: "name",
            Cell: ({ row }: any) => {
                return (
                    <div>
                        {row.original?.name}
                    </div>
                );
            },
            isChecked: true
        },
        ...(isBroker ? [{
            id: 3,
            Header: "Team Admin",
            accessor: "admin",
            Cell: ({ row }: any) => {
                return (
                    <div>
                        {row.original?.admin ? row.original?.admin?.name + ' ' + row.original?.admin?.last_name : '-'}
                    </div>
                );
            },
            isChecked: true
        }] : []),
        {
            id: 4,
            Header: "Team Leader",
            accessor: "leader",
            Cell: ({ row }: any) => {
                return (
                    <div>
                        {row.original?.leader?.name} {row.original?.leader?.last_name}
                    </div>
                );
            },
            isChecked: true
        },
        {
            id: 5,
            Header: "Creted By",
            accessor: "created_by",
            Cell: ({ row }: any) => {
                return (
                    <div>
                        {row.original?.created_by?.name} {row.original?.created_by?.last_name}
                    </div>
                );
            },
            isChecked: true
        },
        {
            id: 6,
            Header: "Team Members",
            accessor: "team_members",
            Cell: ({ row }: any) => {
                return (
                    <div className="cursor-pointer flex">
                        {row.original?.members?.length > 0 ? (
                            row.original?.members.map((user: any, index: number) => (
                                index < 5 && (
                                    user.user_information?.profil_picture !== null ? (
                                        <img src={'https://mainhub.insuhub.ch/api/profile-picture/' + user.user_information?.profil_picture} alt=""
                                            className={`${index !== 0 && '-ml-3'} w-[35px] h-[35px] rounded-full`} key={index} />
                                    ) : (
                                        <img src={'https://st3.depositphotos.com/9998432/13335/v/450/depositphotos_133351928-stock-illustration-default-placeholder-man-and-woman.jpg'}
                                            alt="" className={`${index !== 0 && '-ml-3'} w-[35px] h-[35px] rounded-full flex-none`} key={index} />

                                    )
                                )
                            ))

                        ) : (
                            t('Not available')
                        )}

                        {(row.original?.members?.length > 5) && (
                            <div className="w-[35px] h-[35px] rounded-full -ml-3 bg-[--theme-bg-opacity] border-2 border-white text-[--theme] grid place-items-center font-inter-medium text-xs">
                                {row.original?.members.length - 5}
                            </div>
                        )}
                    </div>
                );
            },
            isChecked: true
        },
        {
            id: 7,
            Header: "Status",
            accessor: "is_active",
            Cell: ({ row }: any) => {
                return (
                    <ToggleSwitchComp
                        id={row.original.id}
                        value={row.original.is_active}
                        type={row.original.type}
                    />
                );
            },
            isChecked: true
        },
        {
            Header: "",
            accessor: "actions",
            id: 8,
            Cell: ({ row }: any) => (
                <ActionButton
                    id={row.original.id}
                    value={row.original.status}
                    original={row.original}
                />
            ),
            isChecked: true
        }
    ]
}

const ActionButton = ({ original, id }: any) => {
    const [ThreeDotsOpen, setThreeDotsOpen] = useState(false);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const buttonRef = useRef<any>(null);
    const dropdownRef = useRef<any>(null);

    const hasPermissionToEditTeam = usePermissions(['data_sharing_teams_edit']);
    const hasPermissionToDeleteTeam = usePermissions(['data_sharing_teams_delete']);

    const [IsUpdateModalOpen, setIsUpdateModalOpen] = useState<boolean>(false);
    const [IsDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
    const [UpdateData, setUpdateData] = useState<any>();

    const handleClick = () => {
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            const dropdownWidth = 200;
            setDropdownPosition({
                top: rect.bottom + window.scrollY,
                left: rect.right + window.scrollX - dropdownWidth
            });
        }
        setThreeDotsOpen(!ThreeDotsOpen);
    };


    useEffect(() => {
        const handleClickOutside = (event: any) => {
            if (
                ThreeDotsOpen &&
                buttonRef.current &&
                dropdownRef.current &&
                !buttonRef.current.contains(event.target) &&
                !dropdownRef.current.contains(event.target)
            ) {
                setThreeDotsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [ThreeDotsOpen]);

    if (!hasPermissionToEditTeam && !hasPermissionToDeleteTeam) {
        return null;
    }
    return (
        <div className="flex flex-row items-center w-fit">
            <div className="relative">
                <button
                    ref={buttonRef}
                    type="button"
                    className="pl-5"
                    onClick={handleClick}
                >
                    <Icon iconType={IconType.OPTIONS_ICON} />
                </button>
                {ThreeDotsOpen &&
                    ReactDOM.createPortal(
                        <div
                            style={{
                                position: "absolute",
                                top: `${dropdownPosition.top}px`,
                                left: `${dropdownPosition.left}px`
                            }}
                            ref={dropdownRef}
                        >
                            <div className="shadow-custom py-[15px] px-[21px]  w-[193px]  bg-white flex flex-col text-[14px] gap-1 font-inter-medium rounded-[12px]">
                                <ConditionalRender condition={hasPermissionToEditTeam}>
                                    <div className="pb-3 flex flex-row items-center cursor-pointer" onClick={() => {
                                        setIsUpdateModalOpen(true);
                                        setUpdateData(original);
                                    }}>
                                        <div>
                                            <Icon iconType={IconType.EDIT_SOURCE_ICON} />
                                        </div>
                                        <div className="px-4 text-[14px] font-inter-medium">
                                            {t('Edit')}
                                        </div>
                                    </div>
                                </ConditionalRender>
                                <ConditionalRender condition={hasPermissionToDeleteTeam}>
                                    <div
                                        className=" flex flex-row items-center cursor-pointer"
                                        onClick={() => {
                                            setThreeDotsOpen(false);
                                            setIsDeleteModalOpen(true);
                                            setUpdateData({ id: id, type: original.type });
                                        }}
                                    >
                                        <div>
                                            <Icon iconType={IconType.DELETE_SOURCE_ICON} />
                                        </div>
                                        <div className="px-3 text-[14px] font-inter-medium">
                                            {t('Delete')}
                                        </div>
                                    </div>
                                </ConditionalRender>
                            </div>
                        </div>,
                        document.body
                    )}
            </div>
            <CreateAndUpdateTeam
                clearData={true}
                data={UpdateData}
                isUpdate={true}
                hocClasses={{
                    modalClassName: "w-full sm:max-w-[550px]"
                }}
                onConfirm={() => {
                    setIsUpdateModalOpen(false);
                }}
                hocTitle={'Edit Team'}
                hocCurrentStep={1}
                hocToggleModal={() => { setIsUpdateModalOpen(!IsUpdateModalOpen) }}
                hocisOpen={IsUpdateModalOpen}
                hocHasChanges={false}
            />
            <DeleteTeam
                clearData={true}
                id={UpdateData?.id}
                type={UpdateData?.type}
                hocClasses={{
                    modalClassName: "w-full sm:max-w-[750px]"
                }}
                onConfirm={() => {
                    setIsDeleteModalOpen(false);
                }}
                hocTitle={`Are you sure you want to delete ${original.name} ?`}

                hocCurrentStep={1}
                hocToggleModal={() => { setIsDeleteModalOpen(!IsDeleteModalOpen) }}
                hocisOpen={IsDeleteModalOpen}
                hocHasChanges={false}
            />
        </div>
    );
};

const ToggleSwitchComp = ({ id, value, type }: any) => {
    const [IsChecked, setIsChecked] = useState(value === 1);
    const { mutateAsync: updateStatus, isLoading } = useChangeTeamStatus(type === 'broker');

    const hasPermissionToEditTeam = usePermissions(['data_sharing_teams_edit']);

    React.useEffect(() => {

        setIsChecked(value === 1);

    }, [value]);

    const toggleStatus = async (e: any) => {
        e.preventDefault();
        updateStatus({ team_id: id })
            .then((res: any) => {
                if (res.status !== undefined) {
                    setIsChecked(res.status === 1);
                }
            })
    };

    return (
        <div>
            <ToggleSwitchComponent
                checked={IsChecked}
                onChange={toggleStatus}
                classes={{ label: "!mb-0" }}
                disabled={isLoading || !hasPermissionToEditTeam}
            />
        </div>
    );
};
